import { render, staticRenderFns } from "./jbxx1.vue?vue&type=template&id=0df7829f&scoped=true&"
import script from "./jbxx1.vue?vue&type=script&lang=js&"
export * from "./jbxx1.vue?vue&type=script&lang=js&"
import style0 from "./jbxx1.vue?vue&type=style&index=0&id=0df7829f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7829f",
  null
  
)

export default component.exports